import React from "react";
import { Button, Box, makeStyles, CircularProgress, Tooltip } from "@material-ui/core";
import TranslateIcon from '@material-ui/icons/Translate';

const useStyles = makeStyles((theme) => ({
  button: {
    padding: "2px 16px",
    fontSize: "14px",
    minWidth: 64,
    border: "1px solid transparent",
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
  },
  buttonContainer: {
    display: "flex",
    gap: theme.spacing(1),
    marginLeft: "8px",
  },
}));
export default function AITranslationButton({ 
  onClick, 
  buttonDisabled, 
  isTranslating, 
  allTranslationsFilled, 
  resources 
}) {
  const classes = useStyles();

  const getTooltipTitle = () => {
    if (isTranslating) {
      return resources["TranslatingInProgress"] || "Translating in progress...";
    }
    if (allTranslationsFilled) {
      return resources["AllTranslationsFilled"] || "All translations for this language are already filled";
    }
    return resources["TranslateButton"] || "Translate with AI";
  };

  return (
    <Box className={classes.buttonContainer}>
      <Tooltip title={getTooltipTitle()} placement="right">
        <span>
          <Button
            id="translate-with-ai"
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onClick}
            disabled={buttonDisabled}
          >
            <span className={classes.content}>
              {isTranslating ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                <TranslateIcon />
              )}
            </span>
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}
